import { descriptionFor } from '@/variants'
import { currentVariant } from '@/core/data/session'
import type { Stage, StatusFilter } from '@/core/types'

export function restrictsToCoachVisibility(membership: { isOwner: boolean; isCoach: boolean }): boolean {
  return !membership.isOwner && membership.isCoach
}

export function hiddenStagesFor(visibleNames: readonly string[]): Stage[] {
  const visible = new Set(visibleNames)
  return descriptionFor(currentVariant())
    .columns.filter((c) => !visible.has(c.id))
    .map((c) => c.id)
}

export function resolvedHiddenStages(coachHiddenStages: readonly Stage[] | null): readonly Stage[] {
  return coachHiddenStages ?? descriptionFor(currentVariant()).columns.map((c) => c.id)
}

export function boardHiddenGroupsFor(
  hiddenByUser: readonly StatusFilter[],
  coachHiddenStages: readonly Stage[] | null,
): StatusFilter[] {
  const failClosed: readonly StatusFilter[] = coachHiddenStages === null ? ['zurueckgezogen'] : []
  return [...new Set<StatusFilter>([...hiddenByUser, ...resolvedHiddenStages(coachHiddenStages), ...failClosed])]
}

export function visibleCoachingFilterStage(
  stage: StatusFilter | null,
  hiddenStages: readonly Stage[],
): StatusFilter | null {
  return stage !== null && stage !== 'zurueckgezogen' && hiddenStages.includes(stage) ? null : stage
}
